var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIimpresionsYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5296521_play_video_vlog_youtube_youtube logo_icon 2",
    clipPath: "url(#clip0_0_3195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6238 4.66771C17.4168 3.89322 16.807 3.28337 16.0325 3.0764C14.6286 2.7002 8.99993 2.7002 8.99993 2.7002C8.99993 2.7002 3.37124 2.7002 1.96734 3.0764C1.19303 3.28337 0.583031 3.89322 0.376031 4.66771C0 6.07143 0 9.00023 0 9.00023C0 9.00023 0 11.929 0.376031 13.3326C0.583031 14.1071 1.19303 14.7171 1.96734 14.9241C3.37124 15.3001 8.99993 15.3001 8.99993 15.3001C8.99993 15.3001 14.6286 15.3001 16.0325 14.9241C16.807 14.7171 17.4168 14.1071 17.6238 13.3326C18 11.929 18 9.00023 18 9.00023C18 9.00023 18 6.07143 17.6238 4.66771Z",
    fill: "#ED1F24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.2002 11.7004L11.8766 9.00033L7.2002 6.30029V11.7004Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIimpresionsYoutube);
export default __webpack_public_path__ + "static/media/Iimpresions_youtube.30b490d58846415b7509af75a2274d1b.svg";
export { ForwardRef as ReactComponent };